import { withDataVersion } from '@hakimo-ui/hakimo/util';
import { DataVersion, UnifiedMonitoringProduct } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdateDispatchTimestamp(
  alarmId: string,
  options?: {
    onSuccess?: () => void;
    product?: UnifiedMonitoringProduct;
    dataVersion?: DataVersion;
  }
) {
  const {
    onSuccess,
    product = UnifiedMonitoringProduct.REMOTE_GUARDING,
    dataVersion,
  } = options ?? {};
  const url = `/v2/orm/location_alarms/${alarmId}/modify_updates?product=${product}`;
  const request = new Request(url, { method: 'POST' });
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<null, FormData>(request, {
    getBody: (fd) => fd,
    onSuccessInvalidationKeys: [['location_alarm_updates']],
    onSuccess,
  });
}

export default useUpdateDispatchTimestamp;
